<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.firstName }}
        </p>
        <span class="user-status">{{ userData.roles.map(i => getRoleName(i)).join(', ') }}</span>
      </div>
      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
      </b-avatar>
    </template>

    <b-dropdown-item :to="{ name: 'pages-profile' }" link-class="d-flex align-items-center">
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>{{ $t('Profile') }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      v-has-role="CUSTOMER_ROLES"
      :to="{ name: 'pages-user-create' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="PlusIcon" class="mr-50" />
      <span>{{ $t('Create User') }}</span>
    </b-dropdown-item>

    <b-dropdown-divider />

    <!--<b-dropdown-item
      :to="{ name: 'pages-profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Settings</span>
    </b-dropdown-item>-->

    <!--<b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Pricing</span>
    </b-dropdown-item>-->

    <!--<b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item>-->

    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar } from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import { helper } from '@core/mixins/helper';
import { mapState } from 'vuex';
import { CUSTOMER_ROLES } from '@/constants/roles';

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar
  },
  mixins: [helper],
  data() {
    return {
      avatarText
    };
  },
  computed: {
    ...mapState({
      userData: state => state.auth.user
    })
  },
  methods: {
    logout() {
      this.setLogout();
    }
  },
  setup() {
    return {
      CUSTOMER_ROLES
    };
  }
};
</script>
